
import { z } from "zod";

export const ProjectChecklistSubmissionStatusValues = ["DRAFT", "SUBMITTED", "APPROVED", "REJECTED"] as const;
export const ProjectChecklistSubmissionStatusSchema = z.enum(ProjectChecklistSubmissionStatusValues);
export const ProjectChecklistSubmissionStatus = ProjectChecklistSubmissionStatusSchema.enum;
export type ProjectChecklistSubmissionStatus = (typeof ProjectChecklistSubmissionStatusValues)[number];
